import { render, staticRenderFns } from "./sos_receiver_detail.vue?vue&type=template&id=a7b4a8ee&scoped=true&"
import script from "./sos_receiver_detail.vue?vue&type=script&lang=js&"
export * from "./sos_receiver_detail.vue?vue&type=script&lang=js&"
import style0 from "./sos_receiver_detail.vue?vue&type=style&index=0&id=a7b4a8ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b4a8ee",
  null
  
)

export default component.exports